import React from "react";
import { useTranslation } from "react-i18next";
import OnboardingFrame from "./onboarding-frame";
import { OnboardingFrameProps } from "./onboarding-shared-data";

export default function OnboardingStepWelcome(
	props: Omit<OnboardingFrameProps, "navigateBackwards">,
) {
	const { t } = useTranslation();
	return (
		<OnboardingFrame
			title={t("onboarding.welcome.title")}
			description={t("onboarding.welcome.description")}
			buttonPrimary={{
				label: t("onboarding.welcome.next"),
				onClick: props.navigateForwards,
			}}
		/>
	);
}
